import { RootState } from "src/store";

import { licensesAdapter } from "@dashboard/devices/store/helpers";
import { License } from "@dashboard/devices/types";
import { selectGroupById } from "@dashboard/groups/store/selectors";
import { createSelector } from "@reduxjs/toolkit";

const defaultSelectors = licensesAdapter.getSelectors<RootState>((state) => state.devices.list.licenses.items);

export const selectLicenseById = defaultSelectors.selectById;

const selectLicensesStatus = (state: RootState) => state.devices.list.licenses.status;

const emptyLicenses: License[] = [];

export const selectLicensesByGroupId = createSelector(
    (state: RootState, groupId: number) => selectGroupById(state, groupId),
    (state: RootState) => state.devices.list.licenses.items,
    (group, licensesItems) => {
        if (!group || !group?.licenseIds?.length) {
            return emptyLicenses;
        }

        return group.licenseIds.reduce<License[]>((acc, id) => {
            const license = licensesItems.entities[id];
            if (license) {
                acc.push(license);
            }
            return acc;
        }, []);
    },
);
export const selectLicensesByGroupIds = createSelector(
    (state: RootState, groupIds: number[] | undefined) => groupIds,
    (state: RootState) => state.devices.list.licenses.items,
    (state: RootState) => state.devices.list.groups.items,
    (groupIds, licensesItems, groupsItems) => {
        if (!groupIds?.length) {
            return emptyLicenses;
        }

        const result: License[] = [];
        for (const groupId of groupIds) {
            const group = groupsItems.entities[groupId];
            if (!group?.licenseIds?.length) {
                continue;
            }
            for (const id of group.licenseIds) {
                const license = licensesItems.entities[id];
                if (license) {
                    result.push(license);
                }
            }
        }
        return result.length ? result : emptyLicenses;
    },
);
export const selectLicensesEntities = defaultSelectors.selectEntities;

export default {
    selectLicenseById,
    selectLicensesByGroupId,
    selectLicensesByGroupIds,
    selectLicensesEntities,
    selectLicensesStatus,
};
